export default __webpack_public_path__ + "static/media/bar.316dc36e.jpg";